<template>
  <div>
  <div class="container-fluid thankyou-container">
            <div class="success_message" v-text="this.$root.success_message" v-if="this.$root.success_message != ''"></div>
            <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
            <div class="row">
                <div class="col-12 text-center error-main">
                    <h2 class="text-center font-medium error-title ">Something Went Wrong, Please Try Again</h2>
                     <router-link :to="{name:'cart'}" class="fa fa-arrow-left back-icon">
                        Back to Cart
                     </router-link>
                     </div>
                
            </div>
            
        </div>
  </div>
</template>

<script>
export default {
  name: 'payment_error',
  metaInfo: {
      title: 'Payment error',
      meta: [
        {
          name: 'description',
          content: 'Online fashion shopping destination for the modern women. Buy latest collection of online ethnic wear for women’s, W Kurtas, dresses, bottom wear, tops, palazzos, culottes, skirts, drapes and more.'
        },
        {
          property: 'keywords',
          content: 'Online Shopping for Women,  W for Woman, women’s dresses online, buy women’s dresses online'
        }
      ]
    },
  data() {
        return {
        };
    },
    created: function() {
      window.scrollTo(0, 0);
        this.$root.thankyou_status = false;
        $cookies.set(window.location.hostname.substring(10, 4)+'_thank','');
    }
}
</script>
